"use client"

import { useState } from "react"
import { sendContactMessage } from "../api/contactApi"
import Footer from "../components/Footer"

const ContactSystem = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  })
  const [status, setStatus] = useState({ type: "", message: "" })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setStatus({ type: "", message: "" })

    try {
      const response = await sendContactMessage({
        ...formData,
        recipientType: "admin",
      })

      if (response.success) {
        setStatus({ type: "success", message: "Message sent successfully!" })
        setFormData({ fullName: "", email: "", subject: "", message: "" })
      } else {
        setStatus({ type: "error", message: response.message || "Failed to send message." })
      }
    } catch (error) {
      setStatus({ type: "error", message: "An error occurred. Please try again later." })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n  \n    .contact-header {\n      text-align: center;\n      padding: 60px 20px 40px;\n    }\n    .contact-header h1 {\n      font-weight: 800;\n      color: #002b5c;\n    }\n    .contact-header p {\n      color: #6c757d;\n    }\n    .contact-card {\n      background:  var(--info-card);\n      border-radius: 16px;\n      padding: 30px;\n      box-shadow: rgba(0, 0, 0, 0.08) 0px 6px 20px;\n      height: 100%;\n    }\n    \n    .info-box {\n      display: flex;\n      align-items: start;\n      margin-bottom: 20px;\n    }\n    .info-box i {\n      font-size: 1.6rem;\n      margin-right: 15px;\n      color: #004aad;\n    }\n    iframe {\n      border-radius: 16px;\n    }\n\n    \n    \n  ",
        }}
      />
      {/* Navbar */}

      {/* HERO */}
      <section className="hero1">
        <div className="container-lg">
          <div className="row g-3 justify-content-center">
            <div className="col-lg-8 py-4">
              <h3 style={{ textTransform: "uppercase" }} className="fw-bold">
                Contact Us
              </h3>
            </div>
          </div>
        </div>
      </section>
      <section className="features py-5">
        <div className="container-lg">
          <div className="row g-4">
            {/* Contact Form */}
            <div className="col-lg-6">
              <div className="contact-card destination">
                <h4 className="fw-bold mb-3">Send Us a Message</h4>
                {status.message && (
                  <div className={`alert ${status.type === "success" ? "alert-success" : "alert-danger"}`} role="alert">
                    {status.message}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="fullName"
                      className="form-control"
                      placeholder="Enter your full name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Message subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Message</label>
                    <textarea
                      name="message"
                      className="form-control"
                      rows={5}
                      placeholder="Write your message here"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary-navy w-100" disabled={loading}>
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
            {/* Contact Info + Map */}
            <div className="col-lg-6">
              <div className="contact-card mb-4">
                <h4 className="fw-bold mb-3">Get in Touch</h4>
                <div className="info-box">
                  <i className="bi bi-geo-alt-fill" />
                  <div>
                    <strong>Our Office</strong>
                    <br />
                    123 Marina Blvd, Suite 100
                    <br />
                    Port City, Coastal Region 54321
                  </div>
                </div>
                <div className="info-box">
                  <i className="bi bi-telephone-fill" />
                  <div>
                    <strong>Phone</strong>
                    <br />
                    +1 (234) 567-890
                  </div>
                </div>
                <div className="info-box">
                  <i className="bi bi-clock-fill" />
                  <div>
                    <strong>Working Hours</strong>
                    <br />
                    Mon - Sat: 9:00 AM - 6:00 PM
                  </div>
                </div>
                {/* Map */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.466804983904!2d39.15085611533475!3d21.48581127656548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d0efbb62d4b9%3A0x9f7af70c9f11b0b!2sPort%20of%20Jeddah!5e0!3m2!1sen!2s!4v1671197897467!5m2!1sen!2s"
                  width="100%"
                  height={250}
                  allowFullScreen=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </>
  )
}

export default ContactSystem
